var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'clearfix',
    'msg-card',
    'msg-card-' + _vm.direction,
    { 'msg-card-full-width': _vm.fullWidth },
  ]},[_c('div',{class:['chat-box-' + _vm.direction]},[_vm._t("default")],2),(_vm.loading || _vm.error)?_c('div',{staticClass:"loading"},[(_vm.loading)?_c('van-loading',{staticClass:"color",attrs:{"size":"20"}}):_vm._e(),(_vm.error)?_c('van-icon',{staticClass:"color",attrs:{"size":"20","name":"warning"},on:{"click":_vm.handleError}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }